<template>
    <div class="callout callout-custom" role="alert">
        <button type="button" class="close" data-dismiss="callout" aria-label="Close" @click="back">
                    <span>×</span>
        </button>
        <h5>It seems you do not have an admin picture yet.</h5>
        <form class="form-type-line mt-20">
                <div class="flex justify-content-start">
                <div class="form-group file-group">
                        <label>Upload Image</label>
                        <input type="file" ref="image" class="form-control" @change="imageSelected" placeholder="Choose..."/>
                </div>
              </div>
        </form>
          <button class="btn btn-bold btn-primary" disabled v-if="loading">
                <circle-spin class="m-0"></circle-spin>
            </button>
          <button class="btn btn-bold btn-primary" v-else type="button" @click="uploadImage">Save and Continue</button>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            image: '',
            loading: false
        }
    },
    methods: {
        imageSelected(event) {
          this.image = event.target.files[0];
        },
        back() {
            this.$emit('back')
        },
        uploadImage() {
        const formData = new FormData();
        formData.append("image", this.image);
        this.loading = true
        axios.patch('/users/update', formData)
        .then(res => {
            this.loading= false
            this.$notify({
            group: 'response',
            type: 'success',
            text: "Image Uploaded",
            duration: 2500,
            });
            setTimeout(() => {
                location.reload()
            }, 3000)
        })
        .catch(err => {
            this.loading= false
            this.$notify({
            group: 'response',
            type: 'error',
            text: `${err.response.data.message}`,
            duration: 5000,
            });
        })
    }
    }
}
</script>